export function normalizeError(error: unknown, message = 'Unknown error') {
    if (error instanceof Error) {
        return error;
    }

    return new Error(message, {cause: error});
}
